import { render, staticRenderFns } from "./ReminderPlanInfo.vue?vue&type=template&id=2752abc3&"
import script from "./ReminderPlanInfo.vue?vue&type=script&lang=js&"
export * from "./ReminderPlanInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports